import { Phone, Mail, MapPin } from "lucide-react";
import { scrollToSection } from "@/App";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-black">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-10">
        <div className="overflow-hidden">
          <h2
            data-testid="footer-brand"
            className="font-display font-black uppercase tracking-tighter leading-[0.85] text-[16vw] lg:text-[11rem] text-outline select-none whitespace-nowrap"
          >
            A E Carpentry
          </h2>
        </div>
        <div className="mt-12 flex flex-col md:flex-row md:items-center justify-between gap-8 border-t border-neutral-800 pt-8">
          <div className="flex flex-wrap gap-x-10 gap-y-4 text-sm text-neutral-400">
            <a data-testid="footer-phone-link" href="tel:0408166415" className="flex items-center gap-2 hover:text-timber transition-colors duration-300">
              <Phone size={14} /> 0408 166 415
            </a>
            <a data-testid="footer-email-link" href="mailto:carpentry.specialists@outlook.com" className="flex items-center gap-2 hover:text-timber transition-colors duration-300">
              <Mail size={14} /> carpentry.specialists@outlook.com
            </a>
            <span className="flex items-center gap-2">
              <MapPin size={14} /> Perth, WA
            </span>
          </div>
          <button
            data-testid="footer-quote-button"
            onClick={() => scrollToSection("#quote")}
            className="self-start md:self-auto border border-timber text-timber hover:bg-timber hover:text-obsidian font-display font-bold uppercase tracking-widest text-sm px-6 py-2.5 transition-colors duration-300"
          >
            Free Measure &amp; Quote
          </button>
        </div>
        <p className="mt-10 text-xs text-neutral-600 uppercase tracking-[0.2em]">
          © {new Date().getFullYear()} A E Carpentry — Roof Carpentry &amp; Timber Framing, Perth WA
        </p>
      </div>
    </footer>
  );
}
